







import Vue from 'vue';
import {Component} from "vue-property-decorator";
import {Icon} from "@/helpers/icons";
import AsiToolbar from "../common/AsiToolbar.vue";
import AsiContentContainer from "../common/AsiContentContainer.vue";
import ReportList from "@/components/report/ReportList.vue";
import ReportListFilter from "@/models/report/ReportListFilter";
import {ReportState} from "@/helpers/constants";

@Component({
	components: {ReportList, AsiContentContainer, AsiToolbar}
})
export default class OfficeReportsToCheck extends Vue {

	private icons = Icon;
	private reportFilterModel: ReportListFilter | null = null;

	public created(): void {
		this.reportFilterModel = new ReportListFilter();
		this.reportFilterModel.states = [ReportState.created];
	}

}
